import { Control } from 'react-hook-form'
import { NewTechnologyFormValues } from '../../store/types'
import { formatTechnologyType } from '../../store/utils'
import { useTranslation } from 'react-i18next'
import { Option } from './Inputs/SelectInput'
import AutocompleteInput from './Inputs/AutocompleteInput'

type SelectTechnologyTypeProps = {
  control: Control<NewTechnologyFormValues, any>
  options: string[] | undefined
  label?: string
  required?: boolean
}

const SelectTechnologyType = ({ control, options, label, required }: SelectTechnologyTypeProps) => {
  const { t } = useTranslation()

  let types: Option[] = []
  if (options) {
    types = options.map(option => ({
      value: option,
      label: formatTechnologyType(option) || option,
    }))
  }

  return (
    <AutocompleteInput
      options={types}
      name="type"
      control={control}
      required={required}
      label={label ?? t('page.adminsPage.form.type')}
      rules={{ required: t('page.adminsPage.form.typeRequired') }}
    />
  )
}

export default SelectTechnologyType
